import common from '@/components/sheets/import/impl/common'

const createBacteremia = common.createBacteremia(false, true)

function createCatheter (prefix, p) {
  const type = p[`${prefix}Type`]
  if (type == null || type === '') {
    return null
  }
  return {
    central: 1,
    type_v2: common.getValue(type, ['C1', 'C3', 'C4', '9']),
    material: common.getValue(p[`${prefix}Material`], [1, 2, 3, 4, 9]),
    insertion: common.newDate(p[`${prefix}Insertion`]),
    insertionSite: common.getValue(
      p[`${prefix}InsertionSite`], [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
    ),
    ventilation: common.getValue(p[`${prefix}Ventilation`], [1, 2, 3, 9]),
    lipids: common.getValue(p[`${prefix}Lipids`], [1, 2, 9]),
    removed: common.getValue(p[`${prefix}Removed`], [1, 2, 9]),
    removal: common.newDate(p[`${prefix}Removal`]),
    removalReason: common.getValue(p[`${prefix}RemovalReason`], [1, 2, 3, 4, 5, 6, 9]),
    laboratory: common.getValue(p[`${prefix}Laboratory`], [1, 2, 9]),
    isColIlcBlcSep: common.getValue(p[`${prefix}IsColIlcBlcSep`], [0, 1, 2, 3, 4, 5, 9]),
    colIlcBlcSep: common.newDate(p[`${prefix}ColIlcBlcSep`]),
    diagDate: common.newDate(p[`${prefix}DiagDate`]),
    colIlcBlcSepOrigin: common.getValue(p[`${prefix}ColIlcBlcSepOrigin`], [1, 2, 3, 5, 9]),
    lipidsDiagnosis: common.getValue(p[`${prefix}LipidsDiagnosis`], [1, 2, 9]),
    divDiag: common.getValue(p[`${prefix}DivDiag`], [1, 2, 3, 4, 5, 9]),
    clinicalSigns: common.getValue(
      p[`${prefix}ClinicalSigns`],
      [1, 2, 9]
    ),
    bioSigns: common.getValue(
      p[`${prefix}BioSigns`],
      [1, 2, 9]
    ),
    adaptedAntibio: common.getValue(
      p[`${prefix}AdaptedAntibio`],
      [1, 2, 9]
    ),
    twoHemocs: common.getValue(
      p[`${prefix}TwoHemocs`],
      [1, 2, 9]
    ),
    microOrganisms: common.getMicroOrganisms(p, `${prefix}`, false),
    covidStatus: common.getValue(p[`${prefix}Covid`], [1, 2, 3, 9])
  }
}

function createList (p, f, n, prefix) {
  const result = []
  for (let i = 0; i !== n; ++i) {
    const elt = f(`${prefix}${i}`, p)
    if (elt != null) {
      result.push(elt)
    }
  }

  return result
}

function createCatheters (p) {
  return createList(p, createCatheter, 7, 'kt')
}

function createBacteremias (p) {
  return createList(p, createBacteremia, 2, 'bact')
}

function createSepsis (prefix, p) {
  const episod = p[`${prefix}Episod`]
  const diagDate = p[`${prefix}DiagDate`]
  if ((episod == null || episod === '') &&
      (diagDate == null || diagDate === '')) {
    return null
  }
  return {
    present: 1,
    episod: common.newDate(episod),
    diagDate: common.newDate(diagDate),
    covidStatus: common.getValue(p[`${prefix}Covid`], [1, 2, 3, 9]),
    origin: common.getValue(p[`${prefix}Origin`], [1, 2, 3, 5, 9]),
    entrance_v2: common.getValue(
      p[`${prefix}Entrance`],
      [
        'C8', 'C9', 'C10', 'C11', 'C12', 'C13', 'C14', 'D2', 'D3', 'D4',
        'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'A9', 'A10',
        'A11', 'A12', 'A13'
      ]
    ),
    lipids: common.getValue(p[`${prefix}Lipids`], [1, 2, 9])
  }
}

function createSepsies (p) {
  return createList(p, createSepsis, 2, 'sepsis')
}

function getFuture (future) {
  if (future === undefined) {
    return undefined
  }

  if (future === null || future === '') {
    return null
  }

  const list = [
    { value: 0, index: 1, code: 'DOM' },
    { value: 1, index: 2, code: 'ETAB' },
    { value: 2, index: 3, code: 'AUTETAB' },
    { value: 9, index: 9, code: 'NC' }
  ]

  const value = parseInt(future, 10)
  if (!isNaN(value)) {
    const v = common.getValue(value, [1, 2, 3, 9])
    const l = list.find(i => i.index === v)
    if (l != null) {
      return l.value
    }
    return null
  }

  const o = list.find(
    i => i.code.toLowerCase() === future.toLowerCase()
  )
  if (o != null) {
    return o.value
  }
  return null
}

function createPatient (year, p) {
  const scOther = common.getOtherSeverityScoreAndValue(p.otherScoreName, p.otherScoreValue)

  return {
    sheetNumber: p.sheetNumber,
    uf: (p.uf != null && p.uf !== '') ? p.uf.toString() : null,
    unitType: common.getUnitTypeCode(year, p.unitType),
    birthdate: common.newDate(p.birthdate),
    sex: common.getValue(p.sex, [1, 2, 3, 9]),
    entry: common.newDate(p.entry),
    birthSite: common.getValue(p.birthSite, [1, 2, 9]),
    origin: common.getValue(p.origin, [1, 2, 3, 4, 5, 6, 9]),
    mainSeverity: common.getSeverity(p.cribII, 'cribII'),
    otherSeverity: common.getSeverity(scOther.v, scOther.n),
    birthWeight: p.birthWeight,
    gestationalAge: p.gestationalAge,
    leucomalacy: common.getValue(p.leucomalacy, [1, 2, 9]),
    dead: common.getValue(p.dead, [1, 2, 9]),
    death: common.newDate(p.death),
    exit: common.newDate(p.exit),
    future: getFuture(p.future),
    covidStatus: common.getValue(p.covidStatus, [1, 2, 3, 9]),
    catheters: [],
    bacteremias: [],
    sepsis: []
  }
}

function createSheet (year, p) {
  const sheet = createPatient(year, p)
  sheet.catheters = createCatheters(p)
  sheet.bacteremias = createBacteremias(p)
  sheet.sepsis = createSepsies(p)

  common.checkMissingColumns(sheet)

  return sheet
}

export default {
  createSheet: createSheet
}
